module.exports = __webpack_public_path__ + "img/guofa1.95d7c301.png";